import React from 'react';

const useCurrentIP = () => {
  const [currentIP, setCurrentIP] = React.useState<string>('101.56.0.0');

  const fetchIpData = async () => {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    setCurrentIP(data.ip);
  };

  React.useEffect(() => {
    fetchIpData().catch(() => {
      setCurrentIP('101.56.0.0');
    });
  }, []);

  return currentIP;
};

export default useCurrentIP;
